export const FOOTER_UI_COPY = {
  primary: {
    label: 'Confirm',
  },
  secondary: {
    label: 'Previous',
  },
  dismiss: {
    label: 'Cancel',
  },
} as const;
